'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserCommissionSchedule } from '../../Entities/User/UserCommissionSchedule';
import { UserCommissionScheduleCollection } from '../../Collections/User/UserCommissionScheduleCollection';

export class UserCommissionScheduleRepository extends CoreRepository {
  public createUserCommissionSchedule(userId: number, commissionId: number, payload: object = {}) {
    return this.webAPI
      .createUserCommissionSchedule(userId, commissionId, payload)
      .then((response) => {
        const userCommission = new UserCommissionSchedule();
        userCommission.hydrate(response);

        return userCommission;
      });
  }

  public updateUserCommissionSchedule(
    userId: number,
    commissionId: number,
    scheduleId: number,
    payload: object = {}
  ) {
    return this.webAPI
      .updateUserCommissionSchedule(userId, commissionId, scheduleId, payload)
      .then((response) => {
        const userCommission = new UserCommissionSchedule();
        userCommission.hydrate(response);

        return userCommission;
      });
  }

  public getUserCommissionSchedules(
    userId: number,
    commissionId: number,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI
      .getUserCommissionSchedules(userId, commissionId, options)
      .then((response) => {
        const collection = new UserCommissionScheduleCollection();

        response.data.forEach((collectionItemData) => {
          const collectionItem = new UserCommissionSchedule();
          collectionItem.hydrate(collectionItemData);

          collection.addItem(collectionItem);
        });

        collection.setOffset(response.offset);
        collection.setLimit(response.limit);
        collection.setTotal(response.total);

        return collection;
      });
  }

  public removeUserCommissionSchedule(userId: number, commissionId: number, scheduleId: number) {
    return this.webAPI
      .removeUserCommissionSchedule(userId, commissionId, scheduleId)
      .then((response) => {
        return response;
      });
  }
}
